// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 129) return "static/chunks/129-57dc2aad17e500b3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "f989efc0062f49bf" + ".js";
};